import EditNoteModal from './EditNoteModal';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $stateParams, $modal, ModalService, ActivityService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        // $scope.activityBanner = 'Edit Activity';
        $scope.activityID = $stateParams.activity;
        $scope.showLoading = false;
        const isUserDealer = ActivityService.isUserDealer();
        $scope.isUserDealer = isUserDealer;
        isUserDealer.then((result) => {
            $scope.isUserDealer = result;
        });

    };

    ctrl.completeActivity = () => {
        $scope.showLoading = true;
        const submitNotePromise = ActivityService.completeActivity($scope.activityID);
        submitNotePromise.then((activity) => {
            $scope.activity = ViewModelService.create(activity, 'cc', 'edge.capabilities.claim.activity.dto.ActivityDTO');
            const notesPromise = ActivityService.getActivityNotes_PSA($scope.activityID);
            notesPromise.then(
                (notes) => {
                    $scope.notes = notes;
                    $scope.showLoading = false;
                },
                (error) => {
                    console.error('note retrieval failed', error);
                }
            );
        });
    };

    ctrl.approveOrRejectActivityPSA = (approveFlag) => {
        $scope.showLoading = true;
        const submitNotePromise = ActivityService.approveOrRejectActivityPSA($scope.activityID, approveFlag);
        submitNotePromise.then((activity) => {
            $scope.activity = ViewModelService.create(activity, 'cc', 'edge.capabilities.claim.activity.dto.ActivityDTO');
            const notesPromise = ActivityService.getActivityNotes_PSA($scope.activityID);
            notesPromise.then(
                (notes) => {
                    $scope.notes = notes;
                    $scope.showLoading = false;
                },
                (error) => {
                    console.error('note retrieval failed', error);
                }
            );
        }).catch((error) => {
            $scope.showLoading = false;
            console.error('activity approval/rejection failed', error);
        });
    };

    ctrl.createActivityNote = () => {
        $modal.open(new EditNoteModal($scope.activity)).result.then((newNote) => {
            $scope.notes.push(newNote);
        });
    };


    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$modal', 'ModalService', 'claim.ActivityService', 'ViewModelService'];

export default fn;
